<template>
  <div class="collection_container">
   <div class="container_main">
     <div class="main_box">
       <img src="https://files.wondercv.com/company/privacy-company-zero.png" alt="">
     </div>
     <div class="main_null">{{text}}</div>
   </div>
   
  </div>
</template>

<script>
export default {
 props: {
   text: {
     type: String,
     default: ""
   }
 }
}
</script>

<style lang="scss" scoped>
.collection_container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 880px;
  height: 524px;
  background-color: #fff;
  .container_main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 112px;
    height: 158px;
    img {
      width: 100%;
      height: 112px;
    }
    .main_null {
      width: 100%;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(96,96,96,1);
      line-height:22px;
      text-align: center;
    }

  }
}
</style>